(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fanclub-form-control"] && !Shopify.designMode) return;
  try {
    
  /* ========== フォーム調整 ========== */
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(() => {
    const appEmbed = document.getElementById('app-embed');

    if (appEmbed && appEmbed.shadowRoot) {
      const shadowRoot = appEmbed.shadowRoot;

      // --- formElement の処理 ---
      const formElement = shadowRoot.querySelector('form');

      if (formElement) {
        formElement.style.margin = '5px 0 0';
        // 必要に応じて他のスタイルもここに追加
      } else {
      }

      // ----- ラベル非表示 -----
      const legendElementsToHide = Array.from(shadowRoot.querySelectorAll('legend')).filter(el => {
        return el.textContent && el.textContent.includes('hide'); // nullチェックとテキスト内容が取得できるかを確認
      });

      if (legendElementsToHide.length > 0) {
        legendElementsToHide.forEach(legend => {
          legend.style.display = 'none';
        });
      }

      // --- appRouterElement の処理 ---
      // shadowRoot のスコープ内に移動
      const appRouterElement = shadowRoot.getElementById('form-container-ref');
      if (appRouterElement) {
        // ----- ここからメディアクエリ -----
        const isPCQuery = window.matchMedia('(min-width: 769px)'); // PC判定のメディアクエリ
        if (isPCQuery.matches) { // PCサイズ(769px以上)
          appRouterElement.style.width = '100%';
        } else { // SPサイズ(769px以上)
          appRouterElement.style.width = '100vw';
        }
        // ----- ここまでメディアクエリ -----
        appRouterElement.style.padding = '0 20px';
        appRouterElement.style.boxSizing = 'border-box';
      } else {
      }

    } else {
    }
  }, 2000); // 遅延時間。アプリの初期化タイミングに合わせる必要があり、調整してください。
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
